export const FETCH_UNIVERSELIST_BEGIN="FETCH_UNIVERSELIST_BEGIN";
export const FETCH_UNIVERSELIST_SUCCESS="FETCH_UNIVERSELIST_SUCCESS";
export const FETCH_UNIVERSELIST_FAILURE="FETCH_UNIVERSELIST_FAILURE";

export const FETCH_UNIVERSEMEMBERS_BEGIN="FETCH_UNIVERSEMEMBERS_BEGIN";
export const FETCH_UNIVERSEMEMBERS_SUCCESS="FETCH_UNIVERSEMEMBERS_SUCCESS";
export const FETCH_UNIVERSEMEMBERS_FAILURE="FETCH_UNIVERSEMEMBERS_FAILURE";
